import type { IconProps } from '../types';

export function AnalyticsIcon({ className, title }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 125"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="M15.9,52.4c4.8,0,8.7-3.9,8.7-8.7c0-1.4-0.3-2.6-0.9-3.8l9.7-7.9c1.5,1.1,3.3,1.8,5.3,1.8c2,0,3.8-0.7,5.3-1.8l9.7,7.9c-0.6,1.1-0.9,2.4-0.9,3.8c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7c0-1.4-0.3-2.6-0.9-3.8l9.7-7.9c1.5,1.1,3.3,1.8,5.3,1.8c4.8,0,8.7-3.9,8.7-8.7s-3.9-8.7-8.7-8.7c-4.8,0-8.7,3.9-8.7,8.7c0,1.4,0.3,2.6,0.9,3.8l-9.7,7.9c-1.5-1.1-3.3-1.8-5.3-1.8 c-2,0-3.8,0.7-5.3,1.8L46.4,29c0.6-1.1,0.9-2.4,0.9-3.8c0-4.8-3.9-8.7-8.7-8.7s-8.7,3.9-8.7,8.7c0,1.4,0.3,2.6,0.9,3.8l-9.7,7.9c-1.5-1.1-3.3-1.8-5.3-1.8c-4.8,0-8.7,3.9-8.7,8.7S11.1,52.4,15.9,52.4z M84.1,20.5c2.6,0,4.7,2.1,4.7,4.7S86.7,30,84.1,30 s-4.7-2.1-4.7-4.7S81.5,20.5,84.1,20.5z M61.4,39c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7 C56.7,41.2,58.8,39,61.4,39z M38.6,20.5c2.6,0,4.7,2.1,4.7,4.7S41.2,30,38.6,30c-2.6,0-4.7-2.1-4.7-4.7S36,20.5,38.6,20.5z M15.9,39c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7C11.2,41.2,13.3,39,15.9,39z"
          fill="currentColor"
        />
        <path
          d="M95.5,79.5h-3.4V43c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v36.5h-6.8v-18c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v18h-6.8V43c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v36.5h-6.8v-18c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v18H4.5c-1.1,0-2,0.9-2,2s0.9,2,2,2h91c1.1,0,2-0.9,2-2S96.6,79.5,95.5,79.5z M80.1,45h8v34.5h-8V45z M57.4,63.5h8v16h-8V63.5z M34.6,45h8v34.5h-8V45z M11.9,63.5h8v16h-8V63.5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
